import React from 'react';
import HomePage from './pages/Homepage';
import {Routes, Route} from 'react-router-dom';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import ForgotPassword from './pages/ForgotPassword';
import Signup from './pages/Signup';
import WritingArea from './pages/WritingArea';
import DashboardSetup from './pages/DashboardSetup'



function App() {

  return (
    <div className='main' >
      <Routes>
          <Route path="/" element={<HomePage/>} />
          <Route path="/signup" element={<Signup/>} />
          <Route path="/login" element={<Login/>} />
          <Route path="/forgotpassword" element={<ForgotPassword/>} />
          <Route
          path="/dashboard"
          element={ <DashboardSetup />}
         />
         <Route
          path="/writingarea"
          element={<WritingArea/>}
         />
         <Route path = "*" element = {<NotFound/>}/> 
      </Routes>
    </div>
  )
}

export default App;
